export class Moneda {
    n?:string;
    idmoneda?:string;
    simbolo?:string;
    nombre?:string;
    bandera?:string;
    codigo:string;
    constructor(){

    }
}